// Standard CRA-style service worker registration, trimmed to this project's
// needs (no localhost validity checks beyond the basics -- we're a hosted
// SPA, not a distributable static site).
const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname.match(/^\[::1\]$/),
);

export function register() {
  if (!("serviceWorker" in navigator)) return;
  // Service workers require a secure context; skip quietly on plain HTTP
  // (e.g. a local dev/scratch backend) rather than throwing.
  if (window.location.protocol !== "https:" && !isLocalhost) return;

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;
    navigator.serviceWorker.register(swUrl).catch((error) => {
      console.error("Service worker registration failed:", error);
    });
  });
}

export function unregister() {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.ready.then((registration) => {
    registration.unregister();
  });
}
